import React, { useState, useEffect, useRef } from "react";
import ReactExport from "react-export-excel";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  userState,
  indicatorState,
  groupListState,
  historyStartDateState,
  historyEndDateState,
  historyGroupState,
  historyEmailState,
  historyPaymentState,
} from "../../stores/atoms";
import UseHistoryItem from "./UseHistoryItem";
import { awsInstance } from "../../actions/api";
import { getToday } from "../../actions/utiles";
import Loading from './../Loading';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

function UseHistory() {
  const user = useRecoilValue(userState);
  const [, setIndicator] = useRecoilState(indicatorState);
  const [groupList, setGroupList] = useRecoilState(groupListState);
  const [historyList, sethistoryList] = useState([]);
  const [excelList, setExcelList] = useState([]);
  const [excelDown, setExcelDown] = useState(false);
  const [startDate, setStartDate] = useRecoilState(historyStartDateState);
  const [endDate, setEndDate] = useRecoilState(historyEndDateState);
  const [groupId, setGroupId] = useRecoilState(historyGroupState);
  const [email, setEmail] = useRecoilState(historyEmailState);
  const [payment, setPayment] = useRecoilState(historyPaymentState);
  const downloadContainerRef = useRef();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setIndicator("홈 > 이용 내역");

    if (startDate && endDate) {
      onSearchClick();
    }

    const downloadButton = downloadContainerRef.current.children[0].children[0];
    downloadButton.classList.add("btn-white");
    downloadButton.classList.add("txt-dark-gray");
    downloadButton.classList.add("font-bold");
    downloadButton.classList.add("p-1");
    downloadButton.classList.add("btn-white-md");
    downloadButton.classList.add("long");
    downloadButton.textContent = "이용내역 파일받기";
    if (!excelDown) {
      downloadButton.setAttribute("disabled", "disabled");
    } else {
      downloadButton.removeAttribute("disabled");
    }

    const getGroupList = async () => {
      try {
        const { data } = await awsInstance.get("/business/group-list", {
          params: {
            id: user.company_id
          },
        });
        if (data.code === "SUCCESS") {
          const groupList = data.data;
          setGroupList(groupList);
        } else {
          setGroupList([]);
        }
      } catch (e) {
        alert(e);
      }
    };

    getGroupList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [excelDown]);

  const onSearchClick = async () => {
    if (!startDate || !endDate) {
      alert("기간을 선택해주세요.");
      return;
    }

    try {
      setLoading(true);
      const { data } = await awsInstance.get("/business/history-list", {
        params: {
          id: user.company_id,
          start_date: startDate,
          end_date: endDate,
          group_id: groupId === "" ? null : groupId,
          email: email ? email : "",
          is_tax_bill: payment === "" ? null : payment
        }
      });
      if (data.code === "SUCCESS") {
        const historyList = data.data;
        sethistoryList(historyList);
        setExcelDown(true);
        const excelHistoryList = JSON.parse(JSON.stringify(historyList));
        setExcelList(
          excelHistoryList.map((history) => {
            history.id = getId(history.id, history.service_type);
            history.status = history.status === 300 ? "운행완료" : "운행취소";
            history.service = history.period ? "시간 대절" : "일반 예약";
            history.vehicle = history.vehicle_type_symbol ? `${history.vehicle_type_symbol}${history.vehicle_use_symbol} ${history.vehicle_number}` : '';
            history.payment_fare =
              history.total_fare > 0 ? history.total_fare : history.fee;
            history.payment_method =
              history.is_tax_bill === 1 ? "세금계산서" : "카드";
            history.payment_status = history.receipt
              ? "결제 성공"
              : history.is_tax_bill === 1
              ? "세금계산서"
              : "결제 실패";
            history.completed_date = history.completed_date ? history.completed_date : history.canceled_date;
            return history;
          })
        );
      } else {
        sethistoryList([]);
        setExcelDown(false);
      }
    } catch (e) {
      alert(e);
    } finally {
      setLoading(false);
    }
  };

  const getId = (id, serviceType) => {
    switch (serviceType) {
      case 0:
        return `BC${id}`;
      case 1:
        return `BR${id}`;
      case 2:
        return `BD${id}`;
      default:
          return '';
    }
  };

  return (
    <>
    <div className="use_history" style={{ minWidth: "fit-content" }}>
      <h5 className="title">이용 내역</h5>
      <p className="txt-gray">
        이용번호를 클릭하면 상세내역을 보실 수 있습니다.
      </p>
      <div className="d-flex justify-content-between border-top-gray border-bottom-gray pt-3 pb-3">
        <div className="d-flex align-items-center mr-1">
          <span style={{ minWidth: "2rem" }}>기간</span>
          <input
            className="form-control mr-1 ml-1"
            type="date"
            value={startDate}
            min="2021-01-01"
            max={getToday()}
            style={{ width: "11rem" }}
            onChange={(e) => setStartDate(e.target.value)}
          />
          {"~"}
          <input
            className="form-control ml-1"
            type="date"
            value={endDate}
            min="2021-01-01"
            max={getToday()}
            style={{ width: "11rem" }}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>
        <div className="display-flex align-items-center mr-1">
          <span style={{ minWidth: "3rem" }}>그룹명</span>
          <select
            className="form-control ml-1"
            value={groupId}
            onChange={(e) => setGroupId(e.target.value)}
            style={{ minWidth: "200px" }}
          >
            <option value="" className="font-bold">
              모두
            </option>
            {groupList.map((group) => {
              return (
                <option key={group.id} value={group.id} className="font-bold">
                  {group.name}
                </option>
              );
            })}
          </select>
        </div>
        <div className="display-flex align-items-center mr-1">
          <span style={{ minWidth: "5rem" }}>직원 이메일</span>
          <input
            className="form-control ml-1"
            type="text"
            name="email"
            value={email ? email : ""}
            onChange={(e) => setEmail(e.target.value)}
            style={{ minWidth: "10rem" }}
          ></input>
        </div>
        <div className="display-flex align-items-center mr-1">
          <span style={{ minWidth: "4rem" }}>결제수단</span>
          <select
            name="select-payment"
            className="form-control ml-1"
            onChange={(e) => setPayment(e.target.value)}
            style={{ minWidth: "10rem" }}
          >
            <option value="" className="font-bold">
              모두
            </option>
            <option value="0" className="font-bold">
              카드
            </option>
            <option value="1" className="font-bold">
              세금계산서
            </option>
          </select>
        </div>
        <div className="d-flex align-items-center mr-1">
          <button
            className="btn-dark-sm"
            style={{ minWidth: "5rem" }}
            onClick={onSearchClick}
          >
            검색
          </button>
        </div>
      </div>
      <div className="display-flex justify-content-between align-items-center">
        <p className="txt-gray mt-3 font-bold">
          <span className="txt-blue">{historyList.length}건</span>이
          검색되었습니다.
        </p>
        <span ref={downloadContainerRef}>
          <ExcelFile
            filename={`이용내역_${startDate.replaceAll(
              "-",
              ""
            )}_${endDate.replaceAll("-", "")}`}
          >
            <ExcelSheet data={excelList} name="이용내역">
              <ExcelColumn label="이용번호" value="id" />
              <ExcelColumn label="요청일시" value="requested_date" />
              <ExcelColumn label="상품명" value="service" />
              <ExcelColumn label="운행상태" value="status" />
              <ExcelColumn label="탑승일시" value="board_date" />
              <ExcelColumn label="탑승위치" value="start_address" />
              <ExcelColumn label="도착일시" value="completed_date" />
              <ExcelColumn label="도착위치" value="end_address" />
              <ExcelColumn label="이용사유" value="reason" />
              <ExcelColumn label="직원 이메일" value="business_user_email" />
              <ExcelColumn label="직원명" value="business_user_name" />
              <ExcelColumn label="부서명" value="business_user_department" />
              <ExcelColumn label="그룹명" value="business_group_name" />
              <ExcelColumn label="차종" value="vehicle_model" />
              <ExcelColumn label="차량번호" value="vehicle" />
              <ExcelColumn label="드라이버 이름" value="driver_name" />
              <ExcelColumn label="결제금액" value="payment_fare" />
              <ExcelColumn label="결제수단" value="payment_method" />
              <ExcelColumn label="결제일시" value="completed_date" />
              <ExcelColumn label="결제상태" value="payment_status" />
            </ExcelSheet>
          </ExcelFile>
        </span>
      </div>
      <table className="table table-list">
        <tbody>
          <tr className="background-gray txt-white">
            <th className="width-8">
              <span>이용번호</span>
            </th>
            <th className="width-15">
              <span>탑승일시</span>
            </th>
            <th className="width-15">
              <span>직원 이메일</span>
            </th>
            <th className="width-7">
              <span>직원명</span>
            </th>
            <th className="width-7">
              <span>그룹명</span>
            </th>
            <th className="width-7">
              <span>결제수단</span>
            </th>
            <th className="width-7 p-0">
              <span>이용요금</span>
            </th>
            <th className="width-8">
              <span>상태</span>
            </th>
          </tr>
          {historyList.map((value) => {
            return (
              <UseHistoryItem key={value.id} id={value.id} history={value} />
            );
          })}
          {historyList.length === 0 && (
            <>
              <tr>
                <th colSpan="8">
                  <span className="txt-dark-gray">이용 내역이 없습니다.</span>
                </th>
              </tr>
            </>
          )}
        </tbody>
      </table>
    </div>
    <Loading loading={loading} />
    </>
  );
}

export default UseHistory;
